import { PropertyDataType } from "../../constants/datatypes";
import IMFilesPropertyDefinition from "../mfiles/IMFilesPropertyDefinition";
import { iRootState } from "../../../rematch/store";
import { IFilterValueListItem } from "./IFilterValueListItem";

export interface IOwnPropertyDefinition {
  ownPropertyName: string;
  displayName: string;
  dataType: PropertyDataType;
  getValues?: (state: iRootState) => IFilterValueListItem[];
}

export const isOwnPropertyDefinition = (toBeDetermined: IMFilesPropertyDefinition | IOwnPropertyDefinition): boolean =>
  // eslint-disable-next-line no-prototype-builtins
  toBeDetermined?.hasOwnProperty("ownPropertyName");
